import {
  FeatureFlagDetails,
  FeatureFlags,
  INITIAL_FEATURE_FLAGS_STATE,
  setFeatureFlags,
} from '../state/feature-flags/feature-flags.slice';
import store from '../store';
import { wrapRequest } from './base';

export type FeatureFlagsResponse = Record<string, FeatureFlagDetails>;

export const getFeatureFlags = async (): Promise<FeatureFlagsResponse> =>
  wrapRequest('get', 'north_standard', `/feature-flags`);

const FEATURE_FLAG_KEYS = Object.keys(INITIAL_FEATURE_FLAGS_STATE.flags);

export const mapBackendFeatureFlagsToFrontend = async (
  flagsObj: FeatureFlagsResponse,
  featureFlagKeys: string[]
) => {
  const result: Record<string, any> = {};
  featureFlagKeys.forEach((key) => {
    const backendKey = key.replace(/^canAccessFeature/, '');
    const backendKeyLower =
      backendKey.charAt(0).toLowerCase() + backendKey.slice(1);
    const backendFlag = flagsObj[backendKeyLower];
    if (backendFlag) {
      // Directly assign backendFlag to the frontend key
      result[key] = backendFlag;
    }
  });
  return result;
};

export const fetchFeatureFlags = async () => {
  try {
    const response = await getFeatureFlags();
    const featureFlags = await mapBackendFeatureFlagsToFrontend(
      response,
      FEATURE_FLAG_KEYS
    );
    store.dispatch(setFeatureFlags(featureFlags as FeatureFlags));
  } catch (error) {
    store.dispatch(setFeatureFlags(INITIAL_FEATURE_FLAGS_STATE.flags));
  }
};
